import React, { useState, useEffect } from "react";
import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { getAuth, sendSignInLinkToEmail, onAuthStateChanged } from "firebase/auth";
import { app } from "../firebase";
import "./NewsLetter.css";

const db = getFirestore(app);
const auth = getAuth(app);

const NewsLetter = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [user, setUser] = useState(null);

  // Check if user is signed in
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  // Show popup after 5 seconds only for guests
  useEffect(() => {
    if (!user) {
      const timer = setTimeout(() => {
        setShowPopup(true);
      }, 5000); // 5 seconds
      return () => clearTimeout(timer);
    }
  }, [user]);

  const handleClose = () => setShowPopup(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    const actionCodeSettings = {
      url: "https://kivora-co.web.app/", // must match your authorized domain
      handleCodeInApp: true,
    };

    try {
      // Save email in Firestore
      await addDoc(collection(db, "newsletter"), {
        email,
        subscribedAt: serverTimestamp(),
      });

      // Send Firebase email link
      try {
        await sendSignInLinkToEmail(auth, email, actionCodeSettings);
        window.localStorage.setItem("emailForSignIn", email);
      } catch (emailError) {
        console.warn("Failed to send email link:", emailError.message);
      }

      setStatus("success");
      setEmail("");
    } catch (error) {
      console.error("Error subscribing:", error);
      setStatus("error");
    }
  };

  if (!showPopup || user) return null; // hide popup if user is signed in

  return (
    <div className="newsletter-popup-overlay">
      <div className="newsletter-popup">
        <button className="close-btn" onClick={handleClose}>
          &times;
        </button>
        <h3>JOIN OUR NEWSLETTER</h3>
        <p>Subscribe and get 10% off your first order!</p>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button
            className="NewsLetter_Button"
            type="submit"
            disabled={status === "loading"}
          >
            {status === "loading" ? "Subscribing..." : "Subscribe"}
          </button>
        </form>

        {status === "success" && (
          <p className="success">
            Thank you! Check your inbox — your 10% coupon is coming 🎉
          </p>
        )}
        {status === "error" && <p className="error">Something went wrong. Please try again.</p>}
      </div>
    </div>
  );
};

export default NewsLetter;
